import React, { Component } from 'react';
import { Container } from '@bit/ui-common.ui-components/ss-components';
import * as UpdatePasswordService from 'services/updatePasswordService';
import * as AppServices from 'services/appService';
import Update from 'components/login/Update';

export default Container({
    state: state => ({ state: {...state.passwordUpdate,
        show: state.app.showPasswordUpdate
    }}),
    services: [
        UpdatePasswordService,
        [
            AppServices,
            'togglePasswordUpdateView'
        ]
    ]
},
class PasswordUpdate extends Component {
    constructor(props) { super(props); }
    render = () => (
        <div>
            <Update {...this.props} />
        </div>
    );
});
